import { Module } from 'vuex';
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import { serializer } from '../../api/shared/serializer';
import moment from 'moment';
import { LikeTypeEnum } from '@/enums/LikeTypeEnum';
import i18n from "@/plugins/vueI18n";
import { defaultFacilityValues } from '@/consts/defaultFacilityValues';

const likesModule: Module<any, any> = {
  namespaced: false,
  state: {
    familyLikes: [],
  },

  mutations: {
    setFamilyLikes(state: any, payload: []) {
      state.familyLikes = payload;
    }
  },

  actions: {
    async getFamilyLikes({ commit }, range) {

      const fromDate = range?.fromDate || moment().add(-1, "months").toDate();
      const toDate = range?.toDate || moment().add(1, "months").toDate();

      const photoTitleTranslation = i18n.t('Likes.SomeUserLikedYourPhoto')
      const albumTitleTranslation = i18n.t('Likes.SomeUserLikedYourAlbum')
      const eventTitleTranslation = i18n.t('Likes.SomeUserLikedYourEvent')
      const timeFormat = this.state.facilityModule.selectedFacility?.timeFormat || defaultFacilityValues.timeFormat

      try {
        const eventsQuery = firebase.firestore().collection("calender")
          .where("facilityId", "==", this.state.authModule.currentFacility)
          .where("start", ">=", fromDate)
          .where("start", "<=", toDate)

        const messagesQuery = firebase.firestore().collection("messages")
          .where("facilityId", "==", this.state.authModule.currentFacility)
          .where("createdAt", ">=", fromDate)
          .where("createdAt", "<=", toDate)

        const [eventsSnap, messagesSnap] = await Promise.all([eventsQuery.get(), messagesQuery.get()])

        const events = serializer.querySnapshotToDocuments<any>(eventsSnap)
        const messages = serializer.querySnapshotToDocuments<any>(messagesSnap)

        const residents = this.state.residentModule.residentsShortData
        const residentsMap = new Map(residents.map((x)=>[x.id, x.name]))

        const fmt = (m: moment.Moment) => `${m.format('DD MMM')}, ${m.format(timeFormat)}`

        const eventsLikes = [];

        events.forEach((eventData) => {
          const eventName = eventData.name;
          const eventDate = moment(eventData.start.seconds * 1000).format('DD MMM');

          if (eventData.galleryLikes?.length) {
            eventData.galleryLikes.forEach((like) => {
              const likeDate = moment(like.date.seconds * 1000)
              eventsLikes.push({
                eventId: eventData.id,
                type: LikeTypeEnum.EventAlbum,
                title: `${like.userName || like.id}${albumTitleTranslation}`,
                likeDateDisplay: fmt(likeDate),
                eventDateDisplay: eventDate,
                likeDate,
                eventName
              });
            });
          }

          if (eventData.galleryPhotos?.length) {
            eventData.galleryPhotos.forEach((photo) => {
              if (photo.likes?.length) {
                photo.likes.forEach((like) => {
                  const likeDate = moment(like.date.seconds * 1000)
                  eventsLikes.push({
                    eventId: eventData.id,
                    type: LikeTypeEnum.EventPhoto,
                    title: `${like.userName || like.id}${photoTitleTranslation}`,
                    likeDateDisplay: fmt(likeDate),
                    eventDateDisplay: eventDate,
                    likeDate,
                    eventName
                  });
                });
              }
            });
          }

          if (eventData.likes?.length) {
            eventData.likes.forEach((like) => {
              const likeDate = moment(like.date.seconds * 1000)
              eventsLikes.push({
                eventId: eventData.id,
                type: LikeTypeEnum.Event,
                title: `${like.userName || like.id}${eventTitleTranslation}`,
                likeDateDisplay: fmt(likeDate),
                eventDateDisplay: eventDate,
                likeDate,
                eventName
              });
            });
          }
        });

        const messagesLikes = []

        messages.forEach((messageData) => {
          if (messageData?.likes?.length) {
            const residentName = residentsMap.get(messageData.residentId) || null
            messageData.likes.forEach((like) => {
              const likeDate = moment(like.date.seconds * 1000)
              messagesLikes.push({
                messageId: messageData.id,
                type: LikeTypeEnum.MessagePhoto,
                title: `${like.userName || like.id}${photoTitleTranslation}`,
                residentName,
                likeDateDisplay: fmt(likeDate),
                likeDate
              });
            });
          }
        })

        const familyLikes = eventsLikes.concat(messagesLikes).sort((a, b) => b.likeDate.diff(a.likeDate))

        commit('setFamilyLikes', familyLikes);

      } catch (error) {
        console.error("Getting Likes Error", error);
      }
    }
  }
};
export default likesModule;
